import { ROLE_KEYS, type User } from '@/types';
import { mockRoles } from './roles';

function permsFor(roleKey: string): string[] {
  return mockRoles.find((r) => r.key === roleKey)?.permissions ?? [];
}

export const mockUsers: User[] = [
  {
    id: 'user_1',
    email: 'admin@example.com',
    fullName: 'Super Admin',
    roles: [ROLE_KEYS.SUPER_ADMIN],
    permissions: permsFor(ROLE_KEYS.SUPER_ADMIN) as User['permissions'],
    isActive: true,
    createdAt: new Date().toISOString(),
    avatarUrl: '',
  },
  {
    id: 'user_2',
    email: 'manager@example.com',
    fullName: 'Manager Mike',
    roles: [ROLE_KEYS.MANAGER],
    permissions: permsFor(ROLE_KEYS.MANAGER) as User['permissions'],
    isActive: true,
    createdAt: new Date().toISOString(),
  },
  {
    id: 'user_3',
    email: 'user@example.com',
    fullName: 'Regular User',
    roles: [ROLE_KEYS.USER],
    permissions: permsFor(ROLE_KEYS.USER) as User['permissions'],
    isActive: true,
    createdAt: new Date().toISOString(),
  },
];

export const mockCredentials: Record<string, string> = {
  'admin@example.com': 'password',
  'manager@example.com': 'password',
  'user@example.com': 'password',
};
